document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate();
});
function showProds(id){
    document.querySelectorAll('.new-product-item').forEach(item=>{
        item.classList.remove('new-product-item--active');
    });
    document.querySelector(`[data-prodid="${id}"]`).classList.add('new-product-item--active');
}
function hideProds(){
    document.querySelectorAll('.new-product-item').forEach(item=>{
        item.classList.remove('new-product-item--active');
    });
}

// function that generates url on label click
function setFilters(){
    setTimeout(function(){
      let allInputs = document.querySelectorAll('.filter-form input:checked');
          let filterArray = [];
          let currenturl = '';
          let finalArray = '';
          let sortby = document.querySelector('.cstm-colelction-sort__dropdown-value--selected').dataset.sortby;
          allInputs.forEach(input=>{
              let value = input.dataset.value;
              let name = input.name;
              let linkInfo = `${name.replace(' ', '+')}=${value}`;
              filterArray.push(linkInfo);
          });
          let minMoney = document.querySelector('.range-min').value;
          let maxMoney = document.querySelector('.range-max').value;
          finalArray = filterArray.join('&'); 
          currenturl = `?${finalArray}&sort_by=${sortby}&filter.v.price.gte=${minMoney}&filter.v.price.lte=${maxMoney}`;
          renderDetails(currenturl.replace(/\s/g, ''));
          setUpSlider();
    }, 150);
}

// function that creates a requst
function renderDetails(url){
    document.getElementById('cstm-collection').classList.add('filters-loading');
    fetch(url).then(function (response) {
        // The API call was successful!
        return response.text();
    }).then(function (html) {
        // Convert the HTML string into a document object
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');
        document.querySelector('.cstm-collection-grid__header-count').innerHTML = doc.querySelector('.cstm-collection-grid__header-count').innerHTML;
        document.querySelector('.cstm-collection-grid__grid-filters').innerHTML = doc.querySelector('.cstm-collection-grid__grid-filters').innerHTML;
        document.querySelector('.cstm-collection-grid__grid-items').innerHTML = doc.querySelector('.cstm-collection-grid__grid-items').innerHTML;
        document.getElementById('cstm-collection').classList.remove('filters-loading');
        document.addEventListener("DOMContentLoaded", function() {
            var endlessScroll = new Ajaxinate();
        });
        setUpSlider();
        setDropdown();
        window.history.pushState('', '', url);
        var lazyLoadInstance = new LazyLoad({
          // Your custom settings go here
        });

    }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
    });

}

function uncheckAll(param){
    document.querySelectorAll(`[data-filtercheck='${param}']`).forEach(checkbox=>{
        checkbox.checked = false;
    });
    setFilters();
}

function setSortBy(option) {
    //prefer to use l.search if you have a location/link object
    let parameter = 'sort_by';
    let url = window.location.href;
    var urlparts = url.split('?');   
    
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {    
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }

        let url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        if (url.indexOf('?') > -1 ){
            renderDetails(`${url}&sort_by=${option}`);
        } else {
            renderDetails(`${url}?sort_by=${option}`);
        }
    } else {
        if (url.indexOf('?') > -1 ){
            renderDetails(`${url}&sort_by=${option}`);
        } else {
            renderDetails(`${url}?sort_by=${option}`);
        }
    }

}

function setSelected(option, name){
    if (document.querySelectorAll('.cstm-colelction-sort__dropdown-value--selected')){
        document.querySelectorAll('.cstm-colelction-sort__dropdown-value--selected').forEach(item=>{
            item.classList.remove('cstm-colelction-sort__dropdown-value--selected');
        });
        document.querySelector(`[data-sortby="${option}"]`).classList.add('cstm-colelction-sort__dropdown-value--selected');
    }
    if (document.querySelector('.cstm-collection-sort__tit')){
        document.querySelector('.cstm-collection-sort__tit').innerHTML = name;
    }
    // document.querySelector('.cstm-colleciton-sort-title').textContent = document.querySelector(`[data-sortby="${option}"]`).textContent;
}

function setUpSlider(){
    const rangeInput = document.querySelectorAll(".range-input input"),
    priceInput = document.querySelectorAll(".price-input input"),
    range = document.querySelector(".slider .progress");
    let priceGap = 1;

    let minPrice = parseInt(priceInput[0].value),
    maxPrice = parseInt(priceInput[1].value);
    rangeInput[0].value = minPrice;
    if (minPrice > 0){
        range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
    }
    rangeInput[1].value = maxPrice;
    if (maxPrice > 0 ){
        range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
    }
    priceInput.forEach(input =>{
        input.addEventListener("input", e =>{
            let minPrice = parseInt(priceInput[0].value),
            maxPrice = parseInt(priceInput[1].value);
            if((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max){
                if(e.target.className === "input-min"){
                    rangeInput[0].value = minPrice;
                    if (minPrice > 0){
                        range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
                    }
                }else{
                    rangeInput[1].value = maxPrice;
                    if (maxPrice > 0 ){
                        range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
                    }
                }
            }
        });
    });

    rangeInput.forEach(input =>{
        input.addEventListener("input", e =>{
            let minVal = parseInt(rangeInput[0].value),
            maxVal = parseInt(rangeInput[1].value);

            if((maxVal - minVal) < priceGap){
                if(e.target.className === "range-min"){
                    rangeInput[0].value = maxVal - priceGap
                }else{
                    rangeInput[1].value = minVal + priceGap;
                }
            }else{
                priceInput[0].value = minVal;
                priceInput[1].value = maxVal;
                range.style.left = ((minVal / rangeInput[0].max) * 100) + "%";
                range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
            }
        });
    });
    document.querySelector('.range-min').addEventListener('change', function(){
        setFilters();
    });
    document.querySelector('.range-max').addEventListener('change', function(){
        setFilters();
    });
}
setUpSlider();

document.querySelector('.cstm-colleciton-sort-title').addEventListener('click', function(){
    document.querySelector('.cstm-colelction-sort__dropdown').classList.toggle('cstm-colelction-sort__dropdown--opened');
});

document.querySelectorAll('.cstm-colelction-sort__dropdown-value').forEach(item=>{
    item.addEventListener('click', function(){
        document.querySelector('.cstm-colelction-sort__dropdown').classList.toggle('cstm-colelction-sort__dropdown--opened');
    }); 
});

function setDropdown(){
    document.querySelectorAll('[data-block]').forEach(item=>{
        item.addEventListener('click', function(){
            let iteminfo = item.dataset.block;
            document.querySelector(`[data-dropdn='${iteminfo}']`).classList.toggle('filter-form__list--closed');
            item.parentNode.classList.toggle('filter-form__title-name--closed');
            item.closest('.filter-form__holder').classList.toggle('filter-form__holder--closed');
        });
    });
}


setDropdown();

function hasClass(ele, cls) {
    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

function addClass(ele, cls) {
    if (!hasClass(ele, cls)) ele.className += " " + cls;
}

function removeClass(ele, cls) {
    if (hasClass(ele, cls)) {
        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        ele.className = ele.className.replace(reg, ' ');
    }
}

//Add event from js the keep the marup clean
function init() {
    document.getElementById("open-menu").addEventListener("click", toggleMenu);
    document.getElementById("body-overlay").addEventListener("click", toggleMenu);
}

//The actual fuction
function toggleMenu() {
    var ele = document.getElementsByTagName('body')[0];
    if (!hasClass(ele, "menu-open")) {
        addClass(ele, "menu-open");
    } else {
        removeClass(ele, "menu-open");
    }
}

//Prevent the function to run before the document is loaded
document.addEventListener('readystatechange', function() {
    if (document.readyState === "complete") {
        init();
    }
});